/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_TICK': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 16',
    data: '<path pid="0" _fill="#545454" d="M7.26 15.98L21.81 1.43 20.39.02 7.26 13.15 1.6 7.5.19 8.91l7.07 7.07z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_TICK.js